<template>
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">編輯個人資訊<span class="modal-title text-red ml-3">(我已確實取得客戶同意，為客戶進行資料建檔！)</span></h3>
        </div>
        <div class="modal-body">
          <h4 class="text-green mt-0 mb-3">
            基本資料
          </h4>
          <form class="form">
            <div class="form-row-1">
              <div class="col-half">
                <div class="form-group row">
                  <label for="email" class="col-3 text-right">Email</label>
                  <div class="col-9">
                    <input type="email" class="form-control form-control-inline" v-model="form.email" maxlength="50"
                      @input="checkInputEmail" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="fax" class="col-3 text-right">傳真</label>
                  <div class="col-9 form-fax">
                    <input type="tel" maxlength="5" @input="numberFax0"
                      class="form-control form-control-inline form-short" v-model="form.fax[0]" />
                    <span class="text">-</span>
                    <input type="tel" maxlength="20" @input="numberFax1"
                      class="form-control form-control-inline form-long" v-model="form.fax[1]" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="career" class="col-3 text-right">職業分類</label>
                  <div class="col-9">
                    <b v-if="form.career_box" class="text px-3 text-green">第{{ form.careerCategory }}類 {{
                      form.career_name }}</b>
                    <b v-else class="text px-3 text-green">{{ form.career }}</b>
                    <a class="btn btn-default m-0" @click="jobPickingOpen = true">請選擇</a>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="introducer" class="col-3 text-right">介紹人</label>
                  <div class="col-9">
                    <b v-show="form.introducerId !== ''" class="text px-3 text-green">{{ form.introducer }}</b>
                    <a class="btn btn-red m-0" v-if="form.introducerId !== ''" @click="deleteIntr">刪除</a>
                    <a v-else class="btn btn-default m-0" @click="clientSearchOpen = true">從既有客戶查詢</a>
                  </div>
                </div>
              </div>

              <div class="col-half">
                <div class="form-group row">
                  <label for="agency" class="col-3 text-right">服務單位</label>
                  <div class="col-9">
                    <input type="text" class="form-control form-control-inline" v-model="form.agency" maxlength="30"
                      @input="checkInputAgency" @blur="checkInputAgency" />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="education" class="col-3 text-right">學歷</label>
                  <div class="col-9">
                    <select class="form-control form-control-inline form-wide" v-model="form.education">
                      <option value>請選擇</option>
                      <option v-for="(e, eid) in eduOpt" :key="`city-item-${eid}`" :value="e.val">{{ e.text }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="marriage" class="col-3 text-right">婚姻</label>
                  <div class="col-9">
                    <select class="form-control form-control-inline" v-model="form.marriage">
                      <option value>請選擇</option>
                      <option v-for="(m, mid) in marriageOpt" :key="`city-item-${mid}`" :value="m.val">{{ m.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="education" class="col-3 text-right">居住狀況</label>
                  <div class="col-9">
                    <select class="form-control form-control-inline form-wide" v-model="form.housing_status">
                      <option value>請選擇</option>
                      <option v-for="(h, hid) in housingStatusOpt" :key="`city-item-${hid}`" :value="h.val">{{ h.text }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <h4 class="text-green mt-0 mb-3">
            財務狀況
          </h4>
          <form class="form">
            <div class="form-group row">
              <div class="col-6 d-flex align-items-center">
                <label for="household-income" class="col-3 text-right">家庭年收入</label>
                <div class="col-9">
                  <select class="form-control form-control-inline form-wide" v-model="form.household_income">
                    <option value="">請選擇</option>
                    <option v-for="(c, cid) in householdOpt" :key="`household-item-${cid}`" :value="c.val">{{ c.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <label for="housing" class="col-3 text-right">住宅權屬</label>
                <div class="col-9">
                  <select class="form-control form-control-inline form-wide" v-model="form.housing">
                    <option value="">請選擇</option>
                    <option v-for="(c, cid) in housingOpt" :key="`housing-item-${cid}`" :value="c.val">{{ c.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-6 d-flex align-items-center">
                <label for="houseloan" class="col-3 text-right">房貸金額</label>
                <div class="col-9">
                  <input type="tel" maxlength="10" class="form-control form-control-inline form-short"
                    v-model="form.houseloan">
                  <span class="text ml-2">萬</span>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <label for="monthly-invest" class="col-3 text-right">月平均投資</label>
                <div class="col-9">
                  <select class="form-control form-control-inline form-wide" v-model="form.monthly_invest">
                    <option value="">請選擇</option>
                    <option v-for="(c, cid) in investOpt" :key="`invest-item-${cid}`" :value="c.val">{{ c.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-6 d-flex align-items-center">
                <label for="personal-income" class="col-3 text-right">個人年所得</label>
                <div class="col-9">
                  <select class="form-control form-control-inline form-wide" v-model="form.personal_income">
                    <option value="">請選擇</option>
                    <option v-for="(c, cid) in personalOpt" :key="`city-item-${cid}`" :value="c.val">{{ c.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <label for="vehicle" class="col-3 text-right">交通工具</label>
                <div class="col-9">
                  <select class="form-control form-control-inline form-wide" v-model="form.vehicle">
                    <option value="">請選擇</option>
                    <option v-for="(e, eid) in vehicleOpt" :key="`vehicle-item-${eid}`" :value="e.val">{{ e.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label for="finance-tool" class="col-2 text-left ml-p-10">理財工具</label>
              <div class="col-9 ml-n-30">
                <div class="checkbox checkbox-inline" v-for="(tool, tid) in tools" :key="`tool-item-${tid}`">
                  <input type="checkbox" v-model="form.finance_tool" :id="`tool-item-${tid}`" :value="tool.val">
                  <label :for="`tool-item-${tid}`">{{ tool.text }}</label>
                </div>
              </div>
            </div>
          </form>
          <!-- <h4 class="text-green mt-0">
                備註
          </h4> -->
          <form>
            <div class="form-group row">
              <h4 class="text-green mt-0">
                備註
              </h4>
              <label for="gender-1" class="col-1"></label>
              <div class="col-9">
                <textarea v-model="form.memoText" class="form-control modal-footer" rows="10" maxlength="800"
                  @input="checkInputMemo" @blur="checkInputMemo"></textarea>
                <div class="text-count">
                  輸入 {{ form.memoText.length }} / 800字
                </div>
              </div>
            </div>

            <div class="form-group row agreement-grid-row">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" v-model="confirm_checkbox" id="edit_is_permit">
                <label class="text-red custom-label"
                  for="edit_is_permit">已確實向客戶(潛在客戶)進行個資告知聲明，並留存同意佐證備查，再建立客戶保單資料／進行資料編輯。</label>
              </div>
            </div>
            <div class="action text-right">
              <a @click="$emit('close')" class="btn btn-default">取消</a>
              <a @click.stop.prevent="submit()" class="btn btn-primary">儲存</a>
            </div>
          </form>
        </div>
      </div>
    </div>
    <search-client-modal :open="clientSearchOpen" @submit="submitClient" @close="clientSearchOpen = false" />
    <job-picking-modal :open="jobPickingOpen" @submit="submitJob" @close="jobPickingOpen = false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchClientModal from "./SearchClientModal";
import { commonMixin } from "@/mixins/common";
import JobPickingModal from "./JobPickingModal";

export default {
  name: "BasicInfoModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    socialData: {
      type: Object,
      default: null
    },
    financialData: {
      type: Object,
      default: null
    },
    memoData: {
      type: Object,
      default: null
    },
    custInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['UserInfo']),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === 'box'
    }
  },
  watch: {
    open: "transformToEnum",
    'form.houseloan': function () {
      this.form.houseloan = this.form.houseloan.replace(/[^\d]/g, '');
    },
  },
  components: { SearchClientModal, JobPickingModal },
  data() {
    return {
      jobPickingOpen: false,
      eduOpt: [
        { text: "國中及以下", val: "1" },
        { text: "高中/職", val: "2" },
        { text: "專科", val: "3" },
        { text: "大學", val: "4" },
        { text: "研究所以上", val: "5" }
      ],
      marriageOpt: [
        { text: "未婚", val: "1" },
        { text: "已婚", val: "2" },
        { text: "離婚", val: "3" },
        { text: "其他", val: "4" },
      ],
      housingStatusOpt: [
        { text: "獨居", val: "1" },
        { text: "與家人同住", val: "2" },
        { text: "與65歲以上親屬同住", val: "3" },
        { text: "與照顧者或看護同住", val: "4" },
        { text: "居住於照護機構", val: "5" },
      ],
      clientSearchOpen: false,
      form: {
        // social
        fax: ["", ""],
        email: "",
        career: "",
        career_name: "",
        career_box: "",
        careerCategory: "",
        introducer: "",
        introducerId: "",
        agency: "",
        education: "",
        marriage: "",
        housing_status: "",
        serNo: "",

        //financial
        personal_income: '',
        household_income: '',
        houseloan: '',
        housing: '',
        monthly_invest: '',
        finance_tool: [],
        vehicle: '',

        //memo
        memoText: "",
      },
      householdOpt: [
        { text: '60萬以下', val: '1' },
        { text: '61萬~80萬', val: '2' },
        { text: '81萬~100萬', val: '3' },
        { text: '101萬~150萬', val: '4' },
        { text: '151萬~200萬', val: '5' },
        { text: '201萬~350萬', val: '6' },
        { text: '351萬以上', val: '7' }
      ],
      personalOpt: [
        { text: '無', val: '1' },
        { text: '30萬以下', val: '2' },
        { text: '31~60萬', val: '3' },
        { text: '61~100萬', val: '4' },
        { text: '101~200萬', val: '5' },
        { text: '201萬以上', val: '6' }
      ],
      housingOpt: [
        { text: '自有', val: '1' },
        { text: '租賃', val: '2' },
        { text: '其他親屬所有', val: '3' },
        { text: '其他', val: '4' },
      ],
      investOpt: [
        { text: '無', val: '1' },
        { text: '3千以下', val: '2' },
        { text: '3千~5千', val: '3' },
        { text: '5千~1萬', val: '4' },
        { text: '1萬~2萬', val: '5' },
        { text: '2萬~5萬', val: '6' },
        { text: '5萬以上', val: '7' }
      ],
      vehicleOpt: [
        { text: '無', val: '1' },
        { text: '機車', val: '2' },
        { text: '汽車', val: '3' },
        { text: '機車與汽車', val: '4' }
      ],
      tools: [
        { text: '定存', val: '1' },
        { text: '保險', val: '2' },
        { text: '共同基金', val: '3' },
        { text: '標會', val: '4' },
        { text: '債券', val: '5' },
        { text: '股票', val: '6' },
        { text: '期貨外匯', val: '7' },
        { text: '不動產', val: '8' },
        { text: '其他', val: '9' }
      ],
      confirm_checkbox: false,
    };
  },
  methods: {
    //檢查Email
    checkInputEmail() {
      this.form.email = this.form.email.replace(/[<>!#$^&,"'?%*:;()+{}[\]|~`=\\]/g, '');
    },
    //檢查服務單位
    checkInputAgency() {
      this.form.agency = this.form.agency.replace(/[<>!@#$^&,"'?%*:;+{}[\]|~`=\\]/g, '');
      if (this.stringBytes(this.form.agency, false, 30) > 30) {
        this.form.agency = this.form.agency.substring(0, this.stringBytes(this.form.agency, true, 30));
      }
    },
    numberFax0() {
      this.form.fax[0] = this.form.fax[0].replace(/[^\d]/g, "");
    },
    numberFax1() {
      this.form.fax[1] = this.form.fax[1].replace(/[^\d]/g, "");
    },
    submitClient(member) {
      this.form.introducer = member.name;
      this.form.introducerId = member.id;
      this.clientSearchOpen = false;
    },
    submitJob(job) {
      this.form.career_name = job.job_name;
      this.form.careerCategory = job.job_cat;
      this.form.career_box = job.job_code
      this.jobPickingOpen = false;
    },
    checkWordLimit() {
      // 檢查欄位字數
      if (
        this.form.email.length > 50 ||
        this.form.fax[0].length > 5 ||
        this.form.fax[1].length > 20 ||
        this.form.agency.length > 30
      ) {
        return true;
      } else {
        return false;
      }
    },
    deleteIntr() {
      this.form.introducer = "";
      this.form.introducerId = "";
    },
    deleteCareer() {
      this.form.careerCategory = "";
      this.form.career = "";
    },
    submit() {
      if (!this.confirm_checkbox) {
        this.$toast.info({ title: '未經客戶同意編輯資料' })
        return
      }

      const errMsg = this.checkWordLimit()
      if (errMsg) {
        // 檢查欄位字數
        this.$toast.info({ title: errMsg });
        return
      }

      let emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailPattern.test(this.form.email) || this.form.email === "") {
        if (this.$store.state.custInfo.ID === "") {
          this.form.serNo = this.$store.state.custInfo.serNo;
        }
        this.$emit("submit", this.form);

      } else {
        this.$toast.info({ title: "Email 格式不對請重新輸入" });
      }
    },
    transformToEnum(val) {
      this.confirm_checkbox = false;
      if (val && this.socialData && this.financialData) {
        this.form.email = this.socialData.email;
        this.form.career = this.socialData.career;
        this.form.career_box = this.socialData.career_box;
        this.form.careerCategory = this.socialData.job_cat;
        this.form.career_name = this.socialData.job_name;
        this.form.introducer = this.socialData.introducer;
        this.form.introducerId = this.socialData.introducerId;
        this.form.agency = this.socialData.agency;
        let uncheckEdu = this.eduOpt.filter(
          item => item.text == this.socialData.education
        );
        this.form.education = uncheckEdu.length ? uncheckEdu[0].val : "";
        let uncheckMarriage = this.marriageOpt.filter(
          item => item.text == this.socialData.marriage
        );
        this.form.marriage = uncheckMarriage.length
          ? uncheckMarriage[0].val
          : "";
        const housingStatusCode = String(this.socialData.housing_status_code || "");
        const housingStatusOption = this.housingStatusOpt.find(
          item => item.val === housingStatusCode
        );
        this.form.housing_status = housingStatusOption
          ? housingStatusOption.val
          : "";
        this.form.fax = this.socialData.fax;

        this.form.personal_income = this.financialData.personal_income ? this.personalOpt.filter(item => item.text == this.financialData.personal_income)[0].val : ''
        this.form.household_income = this.financialData.household_income ? this.householdOpt.filter(item => item.text == this.financialData.household_income)[0].val : ''
        this.form.houseloan = this.financialData.houseloan + ''
        this.form.housing = this.financialData.housing ? this.housingOpt.filter(item => item.text == this.financialData.housing)[0].val : ''
        this.form.monthly_invest = this.financialData.monthly_invest ? this.investOpt.filter(item => item.text == this.financialData.monthly_invest)[0].val : ''
        let toolSet = new Set(this.financialData.finance_tool.split(',').map(item => item.trim()))
        this.form.finance_tool = this.tools.filter(item => toolSet.has(item.text)).map(item => item.val)
        this.form.vehicle = this.financialData.vehicle ? this.vehicleOpt.filter(item => item.text == this.financialData.vehicle)[0].val : ''

        this.form.memoText = this.memoData.memo
      }
    },
    stringBytes(c, isSub, size) { //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n = c.length, s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    //檢查備註
    checkInputMemo() {
      let memoText = this.form.memoText
      memoText = memoText.replace(/[{}[\]§|]/g, '');
      if (memoText && this.stringBytes(memoText, false, 400) > 400) {
        this.memo.memoText = memoText.substring(
          0,
          this.stringBytes(memoText, true, 400)
        );
      }
    },
    //計算字元長度 (字串, 是否檢查, 檢查的長度)
    stringBytes(c, isSub, size) {
      var n = c.length, s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    checkWordLimit() {
      let errMsg = ''
      if (this.form.email.length > 50 || this.form.fax[0].length > 5 || this.form.fax[1].length > 20 || this.form.agency.length > 30 || this.form.houseloan.length > 10) {
        if (this.stringBytes(this.form.memoText, false, 400) > 400) {
          errMsg = '內文不得超過200個中文字'
        } else {
          errMsg = '欄位字數超過限制';
        }
      }
      return errMsg
    },
  },
  mounted() { }
};
</script>
<style lang="css" scoped>
.form-row-1 {
  display: flex;
  gap: 20px;
  /* 左右分欄間距 */
}

.col-3 {
  white-space: nowrap !important;
  /* 防止文字換行 */
}

.col-half {
  width: 50%;
}

.row {
  margin: 0 !important;
}

.form-group {
  margin-bottom: 1.4rem !important;
}

.form-control-inline {
  width: calc(100% - 10px);
}

.form-fax {
  display: flex;
  align-items: center;
  gap: 5px;
}

.form-fax .form-short {
  width: 30%;
}

.form-fax .form-long {
  width: 70% !important;
}

.ml-p-10 {
  margin-left: 10px;
}

.ml-n-30 {
  margin-left: -30px;
}

.text-count {
  margin-top: 5px;
  color: #666;
}

.agreement-grid-row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin: 20px 0 !important;
}

.agreement-grid-row .checkbox-inline {
  position: relative;
  margin-left: 8%;
  max-width: 80%;
  margin-right: 0px !important;
}

.checkbox>input+label.custom-label {
  display: block;
  height: auto !important;
  line-height: 1.4 !important;
  padding-left: 50px !important;
  padding-top: 0px !important;
  margin: 0;
  white-space: normal !important;
  color: #ff0000;
}

.agreement-grid-row input[type="checkbox"] {
  position: absolute;
  left: 0;
  top: 3px;
  margin: 0;
}
</style>
